<template>
  <div>
    <b-card :header="'Edit User Data'">

    </b-card>
  </div>
</template>

<script>
export default {
  name: 'PromotionUser'
}
</script>
